var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"width":"100%","height":"100%"}},[_c('v-progress-circular',{attrs:{"size":100,"color":_vm.color,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }